module.exports = __webpack_public_path__ + "static/img/z5.d551458.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/z5.svg
// module id = XVmQ
// module chunks = 1